import {BijbEvent} from '../../models/bijb-event';
import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class BijbEventsState extends LoadableState {
  public static readonly key = 'BijbEventsState';

  @autoserializeAs(BijbEvent, 'bijbEvents')
  public bijbEvents: BijbEvent[] = [];

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;
}
